module.exports = __webpack_public_path__ + "img/banner-Top-L.89a576f2.png";